import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const { nodeEnv, gaId, hotjarId } = publicRuntimeConfig
const isProduction = nodeEnv === 'production'

const renderTrackingAnalyticsScriptsHead = (pdpaStates) => {
  if (!isProduction) return null
  return (
    <>
      {/* facebook pixel */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '137468688210511');
            fbq('track', 'PageView');
          `,
        }}
      />

      {/* Google Analytics */}
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', '${gaId}');
          `,
        }}
      />

      {/* Google Tag Manager */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NLGJRSV');
          `,
        }}
      />

      {/* Line Tracking */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(g,d,o){
              g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
              var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
              var s=d.createElement('script');s.async=1;
              s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
              var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
                })(window, document);
            _lt('init', {
              customerType: 'lap',
              tagId: '7bae7f98-9a88-4b73-8743-e8bae16e4b5d'
            });
            _lt('send', 'pv', ['7bae7f98-9a88-4b73-8743-e8bae16e4b5d']);
          `,
        }}
      />

      {/* Hotjar */}
      <script 
        dangerouslySetInnerHTML={{
          __html: `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hotjarId},hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `
        }}
      />
    </>
  )
}

const TrackingAnalyticsScriptsBody = ({ pdpaStates }) => {
  if (!isProduction) return null
  return (
    <>
      {/* Facebook Pixel */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=137468688210511&ev=PageView&noscript=1"
        />
      </noscript>

      {/* Line Tracking */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://tr.line.me/tag.gif?c_t=lap&t_id=7bae7f98-9a88-4b73-8743-e8bae16e4b5d&e=pv&noscript=1"
        />
      </noscript>
    </>
  )
}

export { renderTrackingAnalyticsScriptsHead, TrackingAnalyticsScriptsBody }
